import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DestroyService } from '../../../services/destroy/destroy.service';
import {
  CalculateShippingModel,
  Country,
  CountryServiceProxy,
  CustomerFilterModel,
  CustomerModel,
  CustomerServiceProxy,
  CustomFeeModel,
  OrderCreateModel,
  OrderModel,
  OrderProductCreateModel,
  OrderServiceProxy,
  ProductFilterModel,
  ProductModel,
  ProductServiceProxy,
  QueryModel,
  State,
} from '../../../../shared/service-proxies/event-service-proxy';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { CustomerHelperService } from '../../../services/customer-helper/customer-helper.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorService } from '../../../services/error/error.service';
import { ModalService } from '../../../services/modal/modal.service';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
    selector: 'app-create-order-page',
    templateUrl: './create-order-page.component.html',
    styleUrl: './create-order-page.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class CreateOrderPageComponent implements OnInit {
  private customerFilter: CustomerFilterModel = new CustomerFilterModel();
  public customers: CustomerModel[] = [];
  public customer: CustomerModel = new CustomerModel();
  public order: OrderCreateModel = new OrderCreateModel();
  public orderModel: OrderModel = new OrderModel();
  searchModel: QueryModel = new QueryModel();
  customerId: string = '';

  private productFilter: ProductFilterModel = new ProductFilterModel();
  public products: ProductModel[] = [];
  public product: ProductModel = new ProductModel();
  requireShipping: boolean = false;
  public productsSelected$ = new BehaviorSubject<boolean>(false);
  public shippingPrice: number = 0;
  public customShippingPrice: number | null = null;

  public countries: Country[] = [];
  public country: Country = new Country();
  public states: State[] = [];

  decorativeLineVisible: boolean = false;
  decorativeCircleVisible: boolean = true;

  pageSize: number = 10;

  currentStep: number = 1;

  fullName: string = '';
  isClearForm: boolean = false;
  isLoadingSend: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public modalService: ModalService,
    private errorService: ErrorService,
    private customerHelper: CustomerHelperService,
    private _customerService: CustomerServiceProxy,
    private _orderService: OrderServiceProxy,
    private _productService: ProductServiceProxy,
    private destroyService: DestroyService,
    private router: Router,
    private authService: AuthService, 
    private _countryService: CountryServiceProxy
  ) {}
  ngOnInit(): void {
    this.order.prefix = "C";
    this.getCustomers();
    this.getProducts();
    this.getCountries();

    this.route.queryParams.subscribe(params => {
      const customerId = params['customerId'];
      if (customerId) {
        this.onCustomerSelected(customerId); 
      }
    });
  }

  getCustomers() {
    this.customerFilter.perPage = this.pageSize;
    this.customerHelper
      .getCustomers(this.customerFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((customers) => {
        this.customers = customers;
      }, error => {
      });
  }

  searchCustomers(searchText: string) {
    if (!searchText.trim()) {
      this.getCustomers(); 
      return;
    }
    this.customerHelper
      .searchCustomers(searchText, this.pageSize)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((customers) => {
        this.customers = customers.map(c => {
          const customerInstance = Object.assign(new CustomerModel(), c.customer);
          customerInstance['matches'] = c.matches; 
          return customerInstance;
        });
      });
  }
  
  onCustomerSelected(customerId: string = '') {
    this.isClearForm = false;
    this._customerService
      .getDetails(customerId)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((customer) => {
        this.customer = customer;
        this.order.customerId = customer.id || '';
        this.order.firstname = customer.firstname || '';
        this.order.lastname = customer.lastname || '';
        this.order.phone = customer.phone || '';
        this.order.email = customer.email || '';
        this.fullName = `${customer.firstname} ${customer.lastname}`;
      });
  }

  private originalProducts: ProductModel[] = [];

  getProducts() {
    this._productService
      .getByFilter(this.productFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(
        (products) => {
          this.originalProducts = products.items
            .filter((p) => p.name)
            .map((p) =>
              Object.assign(new ProductModel(), p, {
                custom: p.name,
              })
          );
          this.products = [...this.originalProducts]; 
          console.log(this.products);
        },
        (error) => {
          console.error(error);
        }
      );
  };

  onProductSelected(productId: string = '') {
    this.isClearForm = false;
      this._productService
        .getDetails(productId)
        .pipe(takeUntil(this.destroyService.onDestroy$))
        .subscribe((product) => {
          this.product = product;
          if (!this.order.products) {
            this.order.products = [];
          }
          const orderProduct = new OrderProductCreateModel();
          orderProduct.productId = product.id;
          orderProduct.name = product.name;
          orderProduct.quantity = 1;
          orderProduct.price = product.price;
          orderProduct.discount = 0;

          this.order.products.push(orderProduct);
          this.productsSelected$.next(this.order.products.length > 0);

          this.checkIfRequireShipping();
          this.calculateShippingPrice()
      })
  }
  
  calculateShippingPrice() {
    const body = new CalculateShippingModel();
    body.companyId = this.authService.getCompanyId();
    body.products = this.order.products;
    body.shippingAddress = this.order.shippingAddress;

    this._orderService.calculateShippingPrice(body)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
        this.shippingPrice = res.total;
      })
  }

  updateShippingPrice(newPrice: number) {
    this.customFee.amount = newPrice;
  } 


  searchProducts(searchText: string) {
   if (!searchText.trim()) {
      this.products = [...this.originalProducts];
      return;
    }
    this.products = this.originalProducts.filter((product) =>
      product.name.toLowerCase().includes(searchText.toLowerCase())
    );
    
  }

  @ViewChild('page') page!: ElementRef;

  onNextStep(maxStep: number) {
    if (!this.requireShipping && this.currentStep === 4) {
      this.currentStep = 5;
    } else if (this.requireShipping && this.currentStep === 3) {
      this.currentStep = 4;
    } else if (this.currentStep <= maxStep) {
      this.currentStep++;
    } 
    setTimeout(() => {
      if (this.page) {
        this.page.nativeElement.scrollTo({
          top: this.page.nativeElement.scrollHeight,
          behavior: 'smooth',
        });
      }
    }, 100);

  }

  checkIfRequireShipping() {
    this.requireShipping = this.order.products.some((p) => {
      const product = this.products.find((prod) => prod.id === p.productId);
      return product?.requireShipping;
    });
  }
  getTotalPrice(product: OrderProductCreateModel): number {
    if (
      product &&
      product.price != null &&
      product.discount != null &&
      product.quantity != null
    ) {
      const total = (product.price - product.discount) * product.quantity;
      return total > 0 ? total : 0;
    }
    return 0;
  }
  getOrderTotal(): number {
    let total = 0;

    if (Array.isArray(this.order.products)) {
      total = this.order.products.reduce(
        (sum, product) => sum + this.getTotalPrice(product),
        0
      );
    }

    if (this.customFee.amount) {
      total += this.customFee.amount;
    }
  return total;
}
  customFee: CustomFeeModel = new CustomFeeModel();

  createOrder() {
    if (!this.order.customFees) {
      this.order.customFees = []; 
    }
    this.sanitizePhoneNumbers();
    this.customFee.name = 'Доставка';
    this.customFee.amount = this.customFee.amount !== this.shippingPrice ? this.customFee.amount : this.shippingPrice;

    this.order.customFees.push(this.customFee);

    console.log(this.order.customFees);
    
    this.isLoadingSend = true;
    this._orderService
      .create(this.order)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((res) => {
        this.isLoadingSend = false;
        console.log(res);
        this.orderModel = res;
        console.log(this.orderModel);
        localStorage.setItem('orderSuccess', 'true');
        setTimeout(() => {
          this.router.navigate(['/orders']);
        }, 50);
      }, error => {
        this.isLoadingSend = false;
        this.errorService.handleError(error, 'Не удалось создать заказ. Попробуйте позже.');
      });
  }

  private sanitizePhone(phone: string): string {
    return phone.length < 6 ? '' : phone;
  }

  private sanitizePhoneNumbers(): void {
    this.order.phone = this.sanitizePhone(this.order.phone);
    if (this.order?.address?.phone) this.order.address.phone = this.sanitizePhone(this.order.address.phone);
    if (this.order?.shippingAddress?.phone) this.order.shippingAddress.phone = this.sanitizePhone(this.order.shippingAddress.phone);
  }


  cancelOrder() {
    this.customer = new CustomerModel();
    this.order = new OrderCreateModel();
    this.productsSelected$.next(false);
    this.requireShipping = false;
    this.currentStep = 1;
    this.decorativeLineVisible = false;
    this.isClearForm = true;
    this.decorativeCircleVisible = false;
  }

  openModal(popup: string) {
    this.modalService.openModal(popup);
  }


  onDecorativeLineChange(newValue: boolean) {
    this.decorativeLineVisible = newValue;
  }

  getCountries() {
    this._countryService.getCountries()
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(countries => {
        this.countries = countries;
        console.log(this.countries);
        
    })
  }

  getStates(event: number) {
    this._countryService.getStatesByCountryId(event)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
        this.states = res;
        console.log(this.states);
    })
  }
  
}
